import { AxiosResponse } from "axios";
import { ApiGenericResponse } from "../ApiGenericResponse";

export class GetSmartLockNonceResData extends ApiGenericResponse {
    nonce: string;
    remainingSeconds: number;
    challengeCode: string;
    lastNonceReceivedAt: Date;

    constructor(response: AxiosResponse) {
        super(response);
        if (response.data && response.data.Payload) {
            this.parse(response.data.Payload);
        }
    }

    public parse(obj: any) {
        if (obj.Nonce) this.nonce = obj.Nonce;
        if (obj.RemainingSeconds) this.remainingSeconds = obj.RemainingSeconds;
        if (obj.ChallengeCode) this.challengeCode = obj.ChallengeCode;
        if (obj.LastNonceReceivedAt) this.lastNonceReceivedAt = obj.LastNonceReceivedAt;
    }
}
